import React from 'react'
import './whychooseBanner.scss'
import bannerData from './bannerData.json'

export default function WhychooseBanner() {
  const ImgPath = require.context(
    '../../../assets/Images/medicalTourism/',
    true,
  )
  return (
    <div>
      <div class="medical-tourism container">
        <h2 class="title">{bannerData.title}</h2>
        <p class="subtitle">{bannerData.subtitle}</p>

        <div class="content-wrapper">
          <div class="image-section">
            <img
              src={ImgPath(`./${bannerData.image}.png`)}
              alt="medical-tourism"
            />
          </div>

          <div class="features-section">
            {bannerData.features.map((data, index) => (
              <div class="feature">
                <img src={ImgPath(`./${data.icon}.png`)} alt="" />
                <h3>{data.title}</h3>
                <p>{data.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
